import { capitalize } from "./capitalize";
import { splitCamelCase } from "./splitCamelCase";

export const getObjectFieldsArray = (obj: Record<string, any>) => Object.keys(obj).map(capitalize).map(splitCamelCase);